import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SalesRoutingModule } from './sales-routing.module';

import { SalesShellComponent } from './sales-shell/sales-shell.component';
import { MonthlyPlanComponent } from './monthly-plan/monthly-plan.component';
import { MonthlyPlanReportComponent } from './monthly-plan-report/monthly-plan-report.component';
import { MonthlyPlanService } from './shared/services/monthly-plan.service';
import { SharedModule } from '@admin/shared/shared.module';

import { TreeTableModule } from 'primeng/treetable';
import { SalesLookupResolveService } from './shared/services/sales-lookup-resolve.service';

@NgModule({
  imports: [CommonModule, SharedModule, TreeTableModule, SalesRoutingModule],
  declarations: [
    SalesShellComponent,
    MonthlyPlanComponent,
    MonthlyPlanReportComponent,
  ],
  providers: [MonthlyPlanService, SalesLookupResolveService],
})
export class SalesModule {}
